import React, { useState, useEffect } from 'react';
import { DateObject, Calendar } from 'react-multi-date-picker';
import CounsellorNavbar from '../CounsellorLayout/CounsellorNavbar';
import CounsellorSidebar from '../CounsellorLayout/CounsellorSidebar';
import CounsellorFooter from '../CounsellorLayout/CounsellorFooter';
import { Container, Card } from "react-bootstrap";
import "react-multi-date-picker/styles/colors/teal.css";
// IMPORT your custom monthly calendar component
import MonthlyCalendar from './MonthlyCalendar';
import { API_URL } from "../../../Constant.js";



// Generate time options in 12-hour format with 5-minute increments
const generateTimeOptions = () => {
  const options = [];
  for (let meridiem of ['AM', 'PM']) {
    for (let h = 1; h <= 12; h++) {
      const hourStr = h < 10 ? '0' + h : '' + h;
      for (let m = 0; m < 60; m += 5) {
        const minuteStr = m < 10 ? '0' + m : '' + m;
        options.push(`${hourStr}:${minuteStr} ${meridiem}`);
      }
    }
  }
  return options;
};

const timeOptions = generateTimeOptions();

// Convert 12-hour time string (e.g. "01:05 PM") to 24-hour "HH:mm"
const parse12TimeTo24 = (timeStr) => {
  if (!timeStr) return '';
  const [time, meridiem] = timeStr.split(' ');
  let [hour, minute] = time.split(':').map(Number);
  if (meridiem === "PM" && hour < 12) hour += 12;
  if (meridiem === "AM" && hour === 12) hour = 0;
  const hStr = hour < 10 ? '0' + hour : '' + hour;
  const mStr = minute < 10 ? '0' + minute : '' + minute;
  return `${hStr}:${mStr}`;
};

// Convert 24-hour "HH:mm:ss" or "HH:mm" to 12-hour "hh:mm AM/PM"
// Updated to ensure minutes are always two digits.
const convert24To12 = (time24) => {
  if (!time24) return '';
  const parts = time24.split(':');
  let hour = parseInt(parts[0], 10);
  let minute = parts[1] || '00';
  minute = minute.padStart(2, '0');
  const meridiem = hour >= 12 ? "PM" : "AM";
  hour = hour % 12;
  if (hour === 0) hour = 12;
  const hourStr = hour < 10 ? '0' + hour : '' + hour;
  return `${hourStr}:${minute} ${meridiem}`;
};

// Group datewise entries for the List View.
// Expects entries with keys: availabilityDate, startTime, endTime.
function groupDatewiseEntries(entries) {
  const dateGroups = {};
  entries.forEach(entry => {
    const date = entry.availabilityDate.split('T')[0];
    if (!dateGroups[date]) dateGroups[date] = [];
    dateGroups[date].push({
      startTime: convert24To12(entry.startTime),
      endTime: convert24To12(entry.endTime)
    });
  });
  const groupsArray = Object.keys(dateGroups).map(date => {
    const sortedSlots = dateGroups[date].sort((a, b) => a.startTime.localeCompare(b.startTime));
    return { date, timeSlots: sortedSlots };
  });
  groupsArray.sort((a, b) => new Date(a.date) - new Date(b.date));

  const finalGroups = [];
  let currentGroup = null;
  groupsArray.forEach(item => {
    if (!currentGroup) {
      currentGroup = { dates: [item.date], timeSlots: item.timeSlots };
    } else {
      const sameSlots = JSON.stringify(item.timeSlots) === JSON.stringify(currentGroup.timeSlots);
      const lastDate = new Date(currentGroup.dates[currentGroup.dates.length - 1]);
      const currentDate = new Date(item.date);
      const diffDays = (currentDate - lastDate) / (1000 * 60 * 60 * 24);
      if (sameSlots && diffDays === 1) {
        currentGroup.dates.push(item.date);
      } else {
        finalGroups.push(currentGroup);
        currentGroup = { dates: [item.date], timeSlots: item.timeSlots };
      }
    }
  });
  if (currentGroup) finalGroups.push(currentGroup);

  return finalGroups.map(group => {
    let dateRange = group.dates[0];
    if (group.dates.length > 1) {
      dateRange = `${group.dates[0]} to ${group.dates[group.dates.length - 1]}`;
    }
    return { dateRange, dates: group.dates, timeSlots: group.timeSlots };
  });
}

// Helper to format a Date object as "YYYY-MM-DD" in local time.
function formatLocalDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function SetAvailability() {
  const [activeTab, setActiveTab] = useState("list");
  const COUNSELOR_ID = localStorage.getItem("loginId");
  // WEEKLY availability state
  const [weeklyHours, setWeeklyHours] = useState([
    { dayOfWeek: 'Sunday', selected: false, startTime: '', endTime: '' },
    { dayOfWeek: 'Monday', selected: false, startTime: '', endTime: '' },
    { dayOfWeek: 'Tuesday', selected: false, startTime: '', endTime: '' },
    { dayOfWeek: 'Wednesday', selected: false, startTime: '', endTime: '' },
    { dayOfWeek: 'Thursday', selected: false, startTime: '', endTime: '' },
    { dayOfWeek: 'Friday', selected: false, startTime: '', endTime: '' },
    { dayOfWeek: 'Saturday', selected: false, startTime: '', endTime: '' },
  ]);

  // DATEWISE (List View) state
  const [datewiseList, setDatewiseList] = useState([]);

  // POPUP for Datewise availability
  const [showDatewisePopup, setShowDatewisePopup] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const [originalDates, setOriginalDates] = useState([]);
  const [timeSlots, setTimeSlots] = useState([{ fromTime: '', toTime: '' }]);
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    fetchWeeklyAvailability();
    fetchDatewiseAvailability();
  }, []);

  const fetchWeeklyAvailability = async () => {
    try {
      const res = await fetch(`${API_URL}api/availability/weekly/counselor/${COUNSELOR_ID}`);
      if (res.ok) {
        const data = await res.json();
        const updated = [...weeklyHours];
        data.forEach(item => {
          const idx = updated.findIndex(w => w.dayOfWeek === item.dayOfWeek);
          if (idx >= 0) {
            updated[idx].startTime = convert24To12(item.startTime);
            updated[idx].endTime = convert24To12(item.endTime);
            updated[idx].selected = true;
          }
        });
        setWeeklyHours(updated);
      }
    } catch (err) {
      console.error("Error fetching weekly availability:", err);
    }
  };

  const saveWeeklyAvailability = async () => {
    const payload = weeklyHours
      .filter(wh => wh.selected && wh.startTime && wh.endTime)
      .map(wh => ({
        counselorId: COUNSELOR_ID,
        dayOfWeek: wh.dayOfWeek,
        startTime: parse12TimeTo24(wh.startTime),
        endTime: parse12TimeTo24(wh.endTime),
        isActive: true,
      }));
    if (payload.length === 0) {
      alert("No weekly hours to save.");
      return;
    }
    try {
      const res = await fetch(API_URL + "api/availability/weekly/set", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        alert("Weekly availability saved successfully!");
        fetchWeeklyAvailability();
      } else {
        alert("Failed to save weekly availability.");
      }
    } catch (err) {
      console.error("Error saving weekly availability:", err);
    }
  };

  const handleWeeklyChange = (index, field, value) => {
    const updated = [...weeklyHours];
    updated[index][field] = value;
    setWeeklyHours(updated);
  };

  const fetchDatewiseAvailability = async () => {
    try {
      const res = await fetch(`${API_URL}api/availability/datewise/counselor/${COUNSELOR_ID}`);
      if (res.ok) {
        const data = await res.json();
        setDatewiseList(data);
      }
    } catch (err) {
      console.error("Error fetching datewise availability:", err);
    }
  };

  const openDatewisePopup = () => {
    setIsEditMode(false);
    setOriginalDates([]);
    setShowDatewisePopup(true);
    setSelectedDates([]);
    setTimeSlots([{ fromTime: '', toTime: '' }]);
  };

  const closeDatewisePopup = () => {
    setShowDatewisePopup(false);
  };

  const addTimeSlotRow = () => {
    setTimeSlots(prev => [...prev, { fromTime: '', toTime: '' }]);
  };

  const removeTimeSlotRow = (index) => {
    const updated = timeSlots.filter((_, i) => i !== index);
    setTimeSlots(updated);
  };

  const handleTimeSlotChange = (index, field, value) => {
    const updated = [...timeSlots];
    updated[index][field] = value;
    setTimeSlots(updated);
  };

  const saveDatewise = async () => {
    if (selectedDates.length === 0) {
      alert("Please select at least one date.");
      return;
    }
    const validTimeSlots = timeSlots.filter(slot => slot.fromTime && slot.toTime);
    if (validTimeSlots.length === 0) {
      alert("Please add at least one complete time slot.");
      return;
    }

    if (isEditMode) {
      const payload = {
        counselorId: COUNSELOR_ID,
        OriginalDates: originalDates,
        Dates: selectedDates.map(dateObj =>
          typeof dateObj.format === 'function'
            ? dateObj.format("YYYY-MM-DD")
            : new DateObject(dateObj, "YYYY-MM-DD").format("YYYY-MM-DD")
        ),
        TimeSlots: validTimeSlots.map(slot => ({
          StartTime: parse12TimeTo24(slot.fromTime),
          EndTime: parse12TimeTo24(slot.toTime)
        }))
      };
      try {
        const res = await fetch(API_URL + "api/availability/datewise/edit", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
        if (res.ok) {
          alert("Datewise availability updated successfully!");
          closeDatewisePopup();
          fetchDatewiseAvailability();
        } else {
          alert("Failed to update datewise availability.");
        }
      } catch (err) {
        console.error("Error updating datewise availability:", err);
      }
    } else {
      let payload = [];
      selectedDates.forEach(dateObj => {
        const dateStr = typeof dateObj.format === 'function'
          ? dateObj.format("YYYY-MM-DD")
          : new DateObject(dateObj, "YYYY-MM-DD").format("YYYY-MM-DD");
        validTimeSlots.forEach(slot => {
          payload.push({
            counselorId: COUNSELOR_ID,
            AvailabilityDate: dateStr,
            StartTime: parse12TimeTo24(slot.fromTime),
            EndTime: parse12TimeTo24(slot.toTime)
          });
        });
      });
      try {
        const res = await fetch(API_URL + "api/availability/datewise/set", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
        if (res.ok) {
          alert("Datewise availability saved successfully!");
          closeDatewisePopup();
          fetchDatewiseAvailability();
        } else {
          alert("Failed to save datewise availability.");
        }
      } catch (err) {
        console.error("Error saving datewise availability:", err);
      }
    }
  };

  // When editing a grouped datewise entry, pre-fill the popup.
  // Map group's timeSlots (with keys startTime/endTime) to modal keys (fromTime/toTime)
  const handleEditGroup = (group) => {
    setIsEditMode(true);
    setOriginalDates(group.dates);
    const dateObjs = group.dates.map(d => new DateObject(d, "YYYY-MM-DD"));
    setSelectedDates(dateObjs);
    setTimeSlots(group.timeSlots.map(slot => ({
      fromTime: slot.startTime,
      toTime: slot.endTime
    })));
    setShowDatewisePopup(true);
  };

  const handleRemoveGroup = async (group) => {
    if (!window.confirm(`Are you sure you want to remove availability for ${group.dateRange}?`))
      return;
    const convertedSlots = group.timeSlots.map(slot => ({
      StartTime: parse12TimeTo24(slot.startTime),
      EndTime: parse12TimeTo24(slot.endTime)
    }));
    const payload = {
      counselorId: COUNSELOR_ID,
      Dates: group.dates,
      TimeSlots: convertedSlots
    };
    try {
      const res = await fetch(API_URL + "api/availability/datewise/remove", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        alert("Availability removed.");
        fetchDatewiseAvailability();
      } else {
        alert("Failed to remove availability.");
      }
    } catch (err) {
      console.error("Error removing datewise availability:", err);
      alert("Error occurred while removing availability.");
    }
  };

  // Get grouped entries for the List View.
  const groupedData = groupDatewiseEntries(datewiseList);

  // --- Styling Objects ---
  const headerStyle = {
    background: 'linear-gradient(45deg, #1976d2, #42a5f5)',
    color: 'white',
    padding: '15px 20px',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };

  const navButtonStyle = {
    backgroundColor: 'white',
    color: '#1976d2',
    border: 'none',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    cursor: 'pointer',
    fontSize: '1.2em',
    fontWeight: 'bold',
    boxShadow: '0px 2px 4px rgba(0,0,0,0.3)'
  };

  const gridContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: '5px',
    marginTop: '20px'
  };

  const dayHeaderStyle = {
    textAlign: 'center',
    fontWeight: 'bold',
    padding: '8px 0',
    borderBottom: '2px solid #1976d2'
  };

  const cellStyle = {
    margin: '2px',
    backgroundColor: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '8px',
    minHeight: '90px',
    boxShadow: '0px 1px 3px rgba(0,0,0,0.1)',
    position: 'relative',
    cursor: 'pointer'
  };

  const cellHighlightStyle = {
    backgroundColor: 'lightblue',
    borderTop: '2px solid blue'
  };

  const todayStyle = {
    border: '2px solid #ff9800'
  };

  const slotStyle = {
    fontSize: '0.8em',
    marginBottom: '2px',
    backgroundColor: '#f5f5f5',
    padding: '2px 4px',
    borderRadius: '4px',
    marginTop: '3px'
  };

  // Modal styling
  const modalOverlayStyle = {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const modalContentStyle = {
    background: '#fff',
    padding: '20px',
    borderRadius: '4px',
    width: '450px'
  };

  const modalHeaderStyle = {
    marginBottom: '20px',
    fontSize: '1.2em',
    fontWeight: 'bold'
  };

  const modalButtonStyle = {
    padding: '8px 12px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginRight: '10px'
  };

  // ------------------------------------------------

  return (
    <>
      <CounsellorNavbar />
      <div className="d-flex">
        <CounsellorSidebar />
        <Container fluid className="p-4">
          {/* TABS */}
          <div style={{ display: 'flex', justifyContent: "center", marginTop: '20px'}}>
          
            <br />
            <button
              onClick={() => setActiveTab("list")}
              disabled={activeTab === "list"}
              style={{ marginRight: '10px'}}
            >
              List View
            </button>
            <button
              onClick={() => setActiveTab("calendar")}
              disabled={activeTab === "calendar"}
            >
              Calendar View
            </button>
          </div>

          {activeTab === "list" ? (
            <div className="d-flex" style={{ padding: '50px', width: '100%', marginTop: '20px' }}>
              {/* WEEKLY AVAILABILITY */}
              <div style={{ flex: 1, marginRight: '20px' }}>
                <h2>Weekly Availability</h2>
                {weeklyHours.map((wh, index) => (
                  <div key={index} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      checked={wh.selected}
                      onChange={(e) => handleWeeklyChange(index, 'selected', e.target.checked)}
                      style={{ marginRight: '5px' }}
                    />
                    <strong style={{ width: '80px' }}>
                      {wh.dayOfWeek.charAt(0).toUpperCase() + wh.dayOfWeek.slice(1)}:
                    </strong>
                    <select
                      value={wh.startTime}
                      onChange={(e) => handleWeeklyChange(index, 'startTime', e.target.value)}
                      disabled={!wh.selected}
                      style={{ marginRight: '10px' }}
                    >
                      <option value="">Select Time</option>
                      {timeOptions.map(t => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                    <select
                      value={wh.endTime}
                      onChange={(e) => handleWeeklyChange(index, 'endTime', e.target.value)}
                      disabled={!wh.selected}
                    >
                      <option value="">Select Time</option>
                      {timeOptions.map(t => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                  </div>
                ))}
                <button onClick={saveWeeklyAvailability} style={{ marginTop: '10px' }}>
                  Save Weekly
                </button>
              </div>

              {/* DATEWISE AVAILABILITY (LIST) */}
              <div style={{ flex: 1 }}>
                <h2>Datewise Availability</h2>
                <button onClick={openDatewisePopup} style={{ marginBottom: '10px' }}>
                  Set Datewise Availability
                </button>
                <div>
                  <h4>Existing Datewise Entries</h4>
                  {groupedData.length === 0 ? (
                    <p>No datewise availability set.</p>
                  ) : (
                    groupedData.map((group, idx) => (
                      <div
                        key={idx}
                        style={{
                          marginBottom: '10px',
                          borderBottom: '1px solid #ccc',
                          paddingBottom: '5px',
                          display: 'flex'
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <strong>{group.dateRange}</strong>
                        </div>
                        <div style={{ flex: 2 }}>
                          {group.timeSlots.map((slot, i) => (
                            <div key={i}>
                              {slot.startTime} - {slot.endTime}
                            </div>
                          ))}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <button
                            onClick={() => handleEditGroup(group)}
                            style={{ marginRight: '5px', border: 'none', background: 'none', cursor: 'pointer' }}
                          >
                            🖉
                          </button>
                          <button
                            onClick={() => handleRemoveGroup(group)}
                            style={{ border: 'none', background: 'none', cursor: 'pointer' }}
                          >
                            ❌
                          </button>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          ) : (
            // Calendar View – render MonthlyCalendar component
            <MonthlyCalendar counselorId={COUNSELOR_ID} />
          )}

          {/* DATEWISE POPUP for Adding New Availability */}
          {showDatewisePopup && (
            <div
              style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <div style={{ background: '#fff', padding: '20px', borderRadius: '4px', width: '450px' }}>
                <h3>Set Datewise Availability</h3>
                <div style={{ marginBottom: '20px' }}>
                  <Calendar
                    multiple
                    value={selectedDates}
                    onChange={setSelectedDates}
                    format="YYYY-MM-DD"
                  />
                </div>
                {timeSlots.map((slot, index) => (
                  <div key={index} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <label style={{ marginRight: '5px' }}>From:</label>
                    <select
                      value={slot.fromTime}
                      onChange={(e) => handleTimeSlotChange(index, 'fromTime', e.target.value)}
                      style={{ marginRight: '10px' }}
                    >
                      <option value="">Select Time</option>
                      {timeOptions.map(t => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                    <label style={{ marginRight: '5px' }}>To:</label>
                    <select
                      value={slot.toTime}
                      onChange={(e) => handleTimeSlotChange(index, 'toTime', e.target.value)}
                      style={{ marginRight: '10px' }}
                    >
                      <option value="">Select Time</option>
                      {timeOptions.map(t => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                    {index === timeSlots.length - 1 && (
                      <button
                        onClick={addTimeSlotRow}
                        title="Add Time Slot"
                        style={{ fontSize: '20px', lineHeight: '1', marginRight: '5px' }}
                      >
                        +
                      </button>
                    )}
                    {timeSlots.length > 1 && (
                      <button
                        onClick={() => removeTimeSlotRow(index)}
                        title="Remove This Time Slot"
                        style={{ fontSize: '20px', lineHeight: '1' }}
                      >
                        ×
                      </button>
                    )}
                  </div>
                ))}
                <div style={{ marginTop: '20px' }}>
                  <button onClick={saveDatewise} style={{ marginRight: '10px' }}>
                    Save DateTime
                  </button>
                  <button onClick={closeDatewisePopup}>Cancel</button>
                </div>
              </div>
            </div>
          )}
        </Container>
      </div>
      <CounsellorFooter />
    </>
  );
}

export default SetAvailability;
